import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import { globalConfig } from './configuration/config';
import translationDe from './locales/de/translation.json';
import translationSl from './locales/sl/translation.json';

const resources = {
  sl: {
    translation: translationSl,
  },
  de: {
    translation: translationDe,
  },
};

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: globalConfig.get().DefaultLanguage || 'en',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      caches: ['localStorage'],
    },
  });

export default i18n;
